module.exports = window.wptravelengine.publicFragments;